<template>
  <div>
    <nav class="navbar border-bottom" style="min-height: 60px;">
      <div class="app-header-row">
        <button class="hamburger-btn" @click="toggleSidebar" aria-label="Open menu">☰</button>

        <a class="navbar-brand app-logo" @click="goHome" role="button">
          <img class="img-fluid" src="../assets/logo.svg" alt="Logo" />
        </a>

        <!-- Hidden on routes with meta.hideAppSelector (the calendar pages - see router/index.ts). -->
        <div v-if="isSignedIn && !$route.meta.hideAppSelector" class="app-selector" ref="appSelectorRoot">
          <button
              type="button"
              class="app-selector__trigger"
              @click="toggleAppDropdown"
              :aria-expanded="appDropdownOpen"
          >
            <span class="app-selector__label">App</span>
            <span class="app-selector__value">{{ selectedApp || 'All apps' }}</span>
            <span class="app-selector__chevron" :class="{ 'is-open': appDropdownOpen }">▾</span>
          </button>

          <ul v-if="appDropdownOpen" class="app-selector__menu">
            <li v-if="selectedApp">
              <button type="button" class="app-selector__option app-selector__option--clear" @click="selectApp('')">
                All apps
              </button>
            </li>
            <li v-for="app in applications" :key="app">
              <button
                  type="button"
                  class="app-selector__option"
                  :class="{ 'is-active': app === selectedApp }"
                  @click="selectApp(app)"
              >
                {{ app }}
              </button>
            </li>
          </ul>
        </div>

        <!-- Calendar pages: sport selector takes the place of the App selector. -->
        <div v-if="isSignedIn && $route.meta.hideAppSelector" class="app-selector" ref="sportSelectorRoot">
          <button
              type="button"
              class="app-selector__trigger"
              @click="sportDropdownOpen = !sportDropdownOpen"
              :aria-expanded="sportDropdownOpen"
          >
            <span class="app-selector__label">Sport</span>
            <span class="app-selector__value">{{ sportLabel(calendarSport.value) }}</span>
            <span class="app-selector__chevron" :class="{ 'is-open': sportDropdownOpen }">▾</span>
          </button>

          <ul v-if="sportDropdownOpen" class="app-selector__menu">
            <li v-for="sp in sportChoices" :key="sp">
              <button
                  type="button"
                  class="app-selector__option"
                  :class="{ 'is-active': sp === calendarSport.value }"
                  @click="selectSport(sp)"
              >
                {{ sportLabel(sp) }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <Menu :isVisible="sidebarVisible" :reportId="currentReportId" @close="sidebarVisible = false"
    />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Menu from "./Menu.vue";
import AuthService from "@/services/auth-service";
import Cookies from 'js-cookie';
import AdminService from "@/services/admin-service";
import { ALL_SPORTS, calendarSport, setCalendarSport, sportLabel } from "@/utils/calendar-sport";

export default defineComponent({
  name: 'Header',
  components: {
    Menu
  },
  data() {
    return {
      sidebarVisible: false,
      isSignedIn: true,
      selectedApp: null,
      applications: [],
      currentReportId: null,
      appDropdownOpen: false,
      sportDropdownOpen: false,
      sportOptions: [],
      calendarSport
    };
  },
  beforeMount() {
    if (localStorage.getItem('applicationList')) {
      this.applications = JSON.parse(localStorage.getItem('applicationList'));
      const appCookie = Cookies.get('application');
      if (appCookie !== undefined) {
        // Cookie was explicitly set (possibly to '' for "All apps") → respect it as-is
        this.selectedApp = appCookie;
      } else if (this.applications.length) {
        // No cookie at all yet (first visit) → default to first app
        this.selectedApp = this.applications[0]; //first one is procricket, change in case more apps are added
        Cookies.set('application', this.selectedApp);
      }
    } else {
      this.doSignOut ()
    }
  },
  mounted() {
    if (this.$route.meta.hideAppSelector) {
      AdminService.getCalendarStaticData().then((data) => {
        this.sportOptions = data.sports || [];
      }).catch((error) => {
        console.error("Error loading sports:", error);
      });
    }
    document.addEventListener('click', this.handleOutsideClick);
    document.addEventListener('keydown', this.handleEscape);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
    document.removeEventListener('keydown', this.handleEscape);
  },
  computed: {
    sportChoices() {
      const list = [ALL_SPORTS, ...this.sportOptions];
      if (!list.includes(calendarSport.value)) list.push(calendarSport.value);
      return list;
    }
  },
  methods: {
    sportLabel,
    selectSport(sport) {
      this.sportDropdownOpen = false;
      setCalendarSport(sport);
    },
    doSignOut () {
      AuthService.signOut().then(() => {
        this.$router.push('/signin')
      })
    },
    goHome () {
      this.$router.push('/')
    },
    toggleAppDropdown() {
      this.appDropdownOpen = !this.appDropdownOpen;
    },
    selectApp(app) {
      this.appDropdownOpen = false;
      if (app) {
        this.selectedApp = app;
        Cookies.set('application', app);
      } else {
        this.selectedApp = '';
        Cookies.set('application', '');
      }
      location.reload();
    },
    handleOutsideClick(event) {
      const sportRoot = this.$refs.sportSelectorRoot;
      if (this.sportDropdownOpen && sportRoot && !sportRoot.contains(event.target)) {
        this.sportDropdownOpen = false;
      }
      if (!this.appDropdownOpen) return;
      const root = this.$refs.appSelectorRoot;
      if (root && !root.contains(event.target)) {
        this.appDropdownOpen = false;
      }
    },
    handleEscape(event) {
      if (event.key === 'Escape') {
        this.appDropdownOpen = false;
        this.sportDropdownOpen = false;
      }
    },
    toggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
  }
})
</script>

<style src="../assets/style.css">
</style>
